<!-- <mat-spinner [diameter]="20" class="red-color-lottie" [color]="'#FF4081'"></mat-spinner> -->
<!-- <ng-lottie width="22px" height="22px" containerClass="moving-box " [options]="options"></ng-lottie> -->
<div class="spinner" [ngStyle]="{'width': width + 'px', 'height': height + 'px'}"></div>